import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HeatmapModule from 'highcharts/modules/heatmap';
import { t } from 'i18next';

HeatmapModule(Highcharts);

interface Props {
  averageHeatmap: AverageHeatmapProps;
  isPrinting?: boolean;
}

interface AverageHeatmapProps {
  data: number[][];
  xCategories: string[];
  yCategories: string[];
}

// 平均Heatmap生成
export const AverageHeatmapGraph = React.memo(({ averageHeatmap, isPrinting = false }: Props) => {
  const xAxisCategories = averageHeatmap.xCategories ? averageHeatmap.xCategories : [];
  const xAxisMax =averageHeatmap.xCategories ? averageHeatmap.xCategories.length - 1 : 0;

  const option: Highcharts.Options = {
    title: {
      text: '',
    },
    chart: {
      zoomType: 'x',
      height: 30,
      marginLeft: 120,
      marginRight: isPrinting ? 180 : 48,
      marginTop: 0,
      marginBottom: 0,
      shadow: false,
      animation: false,
      backgroundColor: '#FFFFFF',
    },
    xAxis: {
      categories: xAxisCategories,
      min: 0,
      max: xAxisMax,
      tickInterval: 2,
      visible: false,
    },
    yAxis: {
      categories: [t('average', '平均')],
      reversed: false,
      gridLineWidth: 0,
      title: { text: '' },
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
    },
    colorAxis: {
      min: 0,
      floor: 0,
      max: 10,
      minColor: '#EEFFEE',
      maxColor: '#00AA66',
    },
    series: [
      {
        type: 'heatmap',
        boostThreshold: 100,
        data: averageHeatmap.data,
        colsize: 1,
        rowsize: 1,
        index: 0,
        turboThreshold: Number.MAX_VALUE,
        dataLabels: {
          enabled: true,
          color: '#000000',
          style: {
            fontSize: '12px',
          },
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<b>{point.value}</b><br/>',
        },
      },
    ],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
    },
  };

  React.useEffect(() => {
    Highcharts.charts.forEach((chart) => {
      if (chart) {
        chart.reflow();
      }
    });
  }, [isPrinting]);

  return <HighchartsReact highcharts={Highcharts} options={option} />;
});
